import {formatDateTime} from '@/util/scripts/data-transition'
import {request} from '@/util/scripts/request'
import service from '@/business/webcheck/scripts/service'

const GetFailed = '获取失败'

export function checkGEO() {
  return new Promise((resolve, reject) => {
    let timestamp = formatDateTime(Date.now())
    window.navigator.geolocation.getCurrentPosition(
      position => {
        timestamp = formatDateTime(position.timestamp)
        let {latitude, longitude, accuracy} = position.coords
        let location = '未知'
        let coords = `(${latitude},${longitude},${accuracy})`
        //GEO
        request(service.geo, {location: `${latitude},${longitude}`})
          .then(({success, result}) => {
            if (success) {
              let {nation, province, city, district} = result
              location = [nation, province, city, district].join(' ')
            }
          })
          .catch(_ => null)
          .finally(() => resolve({geo: `${location} ${coords}`, timestamp}))//TODO timestamp 格式化：2021年06月01日 星期二 11时20分15秒
      },
      error => resolve({geo: `${GetFailed} (${error.message})`, timestamp})
    )
  })
}